/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import "./ProcessingProgress.scss";
import { cn } from "tailwind-variants";

const FIRST_MESSAGE = "Uploading file";

export default function ProcessingProgress({ message = FIRST_MESSAGE, ...restProps }) {
  return (
    // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
    <div {...restProps} className={cn("processing-progress scope-d7e87e75", restProps.className)}>
      {message}
    </div>
  );
}
